import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";

export interface IPaginationProps {
  pageNumberActive: number;
  pageSize: number;

  totalPages: number;
  totalElements: number;
}

export interface IPageActionProps {
  goToPage: (page: number) => void;
}

export default function Pagination({
  pageNumberActive,
  pageSize,

  totalPages,
  totalElements,
  goToPage,
}: IPaginationProps & IPageActionProps) {
  console.log(pageNumberActive);

  return (
    <div className="flex items-center justify-between border-t rounded-b-2xl border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="flex flex-1 justify-between sm:hidden">
        <button
          disabled={pageNumberActive === 0}
          onClick={() => goToPage(pageNumberActive - 1)}
          className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:bg-gray-200"
        >
          Previous
        </button>
        <button
          disabled={pageNumberActive === totalPages - 1}
          onClick={() => goToPage(pageNumberActive + 1)}
          className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:bg-gray-200"
        >
          Next
        </button>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          {totalElements > 0 && (
            <p className="text-sm text-gray-700">
              Showing{" "}
              <span className="font-medium">
                {pageNumberActive * pageSize + 1}
              </span>{" "}
              to{" "}
              <span className="font-medium">
                {Math.min((pageNumberActive + 1) * pageSize, totalElements)}
              </span>{" "}
              of <span className="font-medium">{totalElements}</span> results
            </p>
          )}
        </div>
        <div>
          <nav
            className="isolate inline-flex -space-x-px rounded-md shadow-sm"
            aria-label="Pagination"
          >
            <button
              disabled={pageNumberActive === 0}
              onClick={() => goToPage(pageNumberActive - 1)}
              className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:bg-gray-200"
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}

            {Array.from(Array(totalPages).keys())
              .map((pn) => {
                // max pages shown
                if (totalPages <= 9) {
                  return pn;
                }
                // fist page
                if (pn === 0) {
                  return pn;
                }
                // last page
                if (pn === totalPages - 1) {
                  return pn;
                }
                const padding = 2;

                // -2 for page 1 and last page
                const spaceRight = totalPages - pageNumberActive - 1;
                const underFlowRight = Math.max(padding - spaceRight, 0);
                console.log("Right", spaceRight, underFlowRight);
                const padLeft = padding + underFlowRight;

                const spaceLeft = pageNumberActive;
                // const spaceLeft = totalPages - pageNumberActive - 1;
                const underFlowLeft = Math.max(padding - spaceLeft, 0);
                console.log("Left", spaceLeft, underFlowLeft);
                const padRight = padding + underFlowLeft;

                // +/- padding around active page
                if (
                  pn >= pageNumberActive - padLeft &&
                  pn <= pageNumberActive + padRight
                ) {
                  return pn;
                }
                return "...";
              })
              // eslint-disable-next-line array-callback-return
              .map((pageNum, index, arr) => {
                if (pageNum === "...") {
                  if (arr[index - 1] !== "...") {
                    if (arr[index + 1] === "...") {
                      return (
                        <span className="relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700">
                          ...
                        </span>
                      );
                    } else {
                      return (
                        <button
                          onClick={() => goToPage(index)}
                          aria-current="page"
                          className="relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
                        >
                          {index + 1}
                        </button>
                      );
                    }
                  }
                } else if (pageNum === pageNumberActive) {
                  return (
                    <button
                      onClick={() => goToPage(pageNum)}
                      aria-current="page"
                      className="relative z-10 inline-flex items-center border border-indigo-500 bg-indigo-50 px-4 py-2 text-sm font-medium text-indigo-600 focus:z-20"
                    >
                      {pageNum + 1}
                    </button>
                  );
                } else {
                  return (
                    <button
                      onClick={() => goToPage(pageNum)}
                      aria-current="page"
                      className="relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
                    >
                      {pageNum + 1}
                    </button>
                  );
                }
              })}

            <button
              disabled={pageNumberActive === totalPages - 1}
              onClick={() => goToPage(pageNumberActive + 1)}
              className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:bg-gray-200"
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}
